export enum GameVersionStatus {
  Archived = "archived",
  Inactive = "inactive",
  Live = "live",
  Unreleased = "unreleased"
}
